if (!customElements.get('header-icons-menu')) {
  customElements.define(
    'header-icons-menu',
    class HeaderIconsMenu extends HTMLElement {
      connectedCallback() {
        this.menus = Array.from(this.querySelectorAll('header-menu'));
        this.lastPointerType = 'mouse';

        this.menus.forEach((menu) => {
          const details = menu.querySelector('details');
          const summary = details?.querySelector('summary');
          if (!summary) return;

          // Con ratón se abre al pasar por encima; en táctil y con teclado, al pulsar
          menu.addEventListener('pointerenter', (event) => {
            if (event.pointerType !== 'mouse') return;
            clearTimeout(menu.closeTimer);
            this.menus.forEach((other) => {
              if (other !== menu && typeof other.close === 'function') other.close();
            });
            details.open = true;
            summary.setAttribute('aria-expanded', 'true');
          });

          menu.addEventListener('pointerleave', (event) => {
            if (event.pointerType !== 'mouse') return;
            menu.closeTimer = setTimeout(() => menu.close?.(), 200);
          });

          summary.addEventListener('pointerdown', (event) => {
            this.lastPointerType = event.pointerType;
          });

          summary.addEventListener('click', (event) => {
            // El elemento principal lleva a su colección: con ratón al hacer clic; en táctil, al pulsarlo con el
            // desplegable ya abierto (el primer toque abre). Con teclado sigue abriendo y cerrando.
            const href = summary.dataset.href;
            if (href && event.detail > 0 && (this.lastPointerType === 'mouse' || details.open)) {
              event.preventDefault();
              window.location.href = href;
              return;
            }

            // Si el ratón ya lo abrió al pasar, el clic no debe cerrarlo
            if (event.detail > 0 && this.lastPointerType === 'mouse' && details.open) {
              event.preventDefault();
              return;
            }
            summary.setAttribute('aria-expanded', details.open ? 'false' : 'true');
          });

          details.addEventListener('keydown', (event) => {
            if (event.key !== 'Escape' || !details.open) return;
            menu.close?.();
            summary.focus();
          });
        });
      }

      disconnectedCallback() {
        this.menus?.forEach((menu) => clearTimeout(menu.closeTimer));
      }
    }
  );
}
